// Minimal, dependency-free wishlist (placeholder) + share behavior for product pages.
// Wishlist has no cart/account backend by design — it only persists a saved-state
// per browser via localStorage so the UI is demonstrable (see custom-wishlist-share.liquid).
const WISHLIST_STORAGE_KEY = 'custom-wishlist-product-ids';

function getWishlistIds() {
  try {
    return JSON.parse(localStorage.getItem(WISHLIST_STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function setWishlistIds(ids) {
  localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(ids));
}

function announce(container, message) {
  const region = container.querySelector('[data-custom-actions-announce]');
  if (region) region.textContent = message;
}

function initWishlistButtons() {
  const buttons = document.querySelectorAll('[data-custom-wishlist-toggle]:not([data-bound])');

  buttons.forEach((button) => {
    button.setAttribute('data-bound', 'true');
    const productId = button.dataset.productId;
    const label = button.querySelector('[data-custom-wishlist-label]');
    const savedLabel = label ? label.textContent : '';
    const isSaved = getWishlistIds().includes(productId);
    button.setAttribute('aria-pressed', String(isSaved));

    button.addEventListener('click', () => {
      const ids = getWishlistIds();
      const index = ids.indexOf(productId);
      const nowSaved = index === -1;

      if (nowSaved) {
        ids.push(productId);
      } else {
        ids.splice(index, 1);
      }

      setWishlistIds(ids);
      button.setAttribute('aria-pressed', String(nowSaved));
      announce(button.closest('.custom-wishlist-share'), nowSaved ? 'Added to wishlist' : 'Removed from wishlist');
      void savedLabel;
    });
  });
}

function initShareButtons() {
  const buttons = document.querySelectorAll('[data-custom-share-trigger]:not([data-bound])');

  buttons.forEach((button) => {
    button.setAttribute('data-bound', 'true');

    button.addEventListener('click', async () => {
      const shareData = { title: button.dataset.shareTitle, url: window.location.href };

      if (navigator.share) {
        try {
          await navigator.share(shareData);
        } catch {
          // user cancelled share — no action needed
        }
        return;
      }

      try {
        await navigator.clipboard.writeText(window.location.href);
        announce(button.closest('.custom-wishlist-share'), 'Link copied to clipboard');
      } catch {
        // clipboard unavailable — silently no-op
      }
    });
  });
}

function initCustomProductActions() {
  initWishlistButtons();
  initShareButtons();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomProductActions);
} else {
  initCustomProductActions();
}

document.addEventListener('shopify:section:load', initCustomProductActions);
